import React from 'react';
import * as R from 'ramda';
import { arrayOf, bool, func, oneOfType, shape, string } from 'prop-types';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import { Info as InfoIcon } from '@mui/icons-material';

import { useGetGlobalCustomersQuery } from 'feature/subscription-plans/enrollment/enrollmentEndpoints';

import { SORT_BY, SORT_BY_TOOLTIP } from './terminalLocatorConstants';

const TooltipMenuItem = ({ disabled, ...props }) => {
  const disabledProps = {
    disableRipple: true,
    sx: {
      backgroundColor: 'transparent !important',
      cursor: 'default',
      opacity: 0.38,
    },
    tabIndex: 0,
    value: undefined,
  };

  return <MenuItem disabled={disabled} {...props} {...(disabled ? disabledProps : null)} />;
};

TooltipMenuItem.propTypes = {
  disabled: bool,
};

TooltipMenuItem.defaultProps = {
  disabled: null,
};

const TerminalLocatorSortBy = ({ location, sortHook: [sortBy, setSortBy], ...props }) => {
  const { data: globalCustomersQuery = [] } = useGetGlobalCustomersQuery();
  const hasAffiliateWithSubscription = globalCustomersQuery.some(affiliate =>
    R.equals(affiliate.hasActiveSubscription, true)
  );

  return (
    <Box {...props}>
      <FormControl
        fullWidth
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
      >
        <InputLabel id="terminal-locator-sort-by">Sort By</InputLabel>
        <Select
          label="Sort By"
          labelId="terminal-locator-sort-by"
          onChange={({ target: { value } }) => {
            // prevent sort by value from being set on click of
            // RWT tooltip icon when the menu item is disabled
            if (
              value === SORT_BY.WAIT_TIMES.value &&
              (!location || !hasAffiliateWithSubscription)
            ) {
              return;
            }

            setSortBy(value);
          }}
          sx={{ flex: 1 }}
          value={sortBy}
        >
          <TooltipMenuItem disabled={!location} value={SORT_BY.DISTANCE.value}>
            {SORT_BY.DISTANCE.label}
          </TooltipMenuItem>
          <TooltipMenuItem
            disabled={!location || !hasAffiliateWithSubscription}
            value={SORT_BY.WAIT_TIMES.value}
          >
            <Tooltip
              title={
                <Box sx={{ textAlign: 'center' }}>
                  {hasAffiliateWithSubscription
                    ? SORT_BY_TOOLTIP.WAIT_TIMES_RESTRICTION
                    : SORT_BY_TOOLTIP.SWIFT_PLUS_REQUIRED}
                </Box>
              }
            >
              <Box
                sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', width: '100%' }}
              >
                {SORT_BY.WAIT_TIMES.label}
                <InfoIcon sx={{ color: 'gray.dark', pl: 0.25, pointerEvents: 'auto', width: 18 }} />
              </Box>
            </Tooltip>
          </TooltipMenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

TerminalLocatorSortBy.propTypes = {
  location: shape({}),
  sortHook: arrayOf(oneOfType([string, func])).isRequired,
};

TerminalLocatorSortBy.defaultProps = {
  location: null,
};

export default TerminalLocatorSortBy;
